<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseSelect
          :options="stationIdSelect.options"
          :data="stationIdSelect.data"
          ref="stationIdSelect">
        </BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseInput
          :options="deviceCodeInput.options"
          :data="deviceCodeInput.data"
          :listener="deviceCodeInput.listener"
        />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;&nbsp; Tải lại
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #index="{index}">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #updateDate="{item}">
            <td>{{ $helper.formatDateDDMMYYYYHHMM(item.updateDate) }}</td>
          </template>
          <template #activeStatus="{item}">
            <td>
              <span class="badge badge-success" v-if="item.activeStatus == 1">Hoạt động</span>
              <span class="badge badge-danger" v-if="item.activeStatus == 0">Không hoạt động</span>
            </td>
          </template>
          <template #connectStatus="{item}">
            <td>
              <span class="badge badge-success" v-if="item.connectStatus == 1">Kết nối</span>
              <span class="badge badge-danger" v-if="item.connectStatus == 0">Mất kết nối</span>
            </td>
          </template>
          <template #volume="{item}">
            <td>
              {{ item.volume + '%' }}
            </td>
          </template>
          <template #stationName="{item}">
            <td>
              <span v-if="item.stationName != null && item.stationName != ''">{{ item.stationName }}</span>
              <span class="badge badge-secondary" v-else>Chưa được gán</span>
            </td>
          </template>
          <template #action="{ item }">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton
                  color="info"
                  variant="outline"
                  v-c-tooltip.hover="'Gán nhóm truyền thanh'"
                  square
                  size="sm"
                  @click="configStation(item)">
                  <i class="fa fa-cog"></i>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>

    <CModal title="Gán nhóm truyền thanh" :show.sync="configStationModal" :closeOnBackdrop="false">
      <CRow class="content-fade-in">
        <CCol md="12">
          <CForm class="form-basic">
            <CRow>
              <CCol sm="12" md="12" xs="12" xl="12">
                <BaseSelect :options="dataConfigStation.stationIdSelect.options"
                            :data="dataConfigStation.stationIdSelect.data"
                            ref="dataConfigStation"></BaseSelect>
              </CCol>
            </CRow>
          </CForm>
        </CCol>

      </CRow>
      <div slot="footer">
        <CButton color="primary" class="btn-action-primary" @click="submitConfigStation()"
                 :disabled="dataConfigStation.loading.value"><i
          class="fa fa-check"></i> Đồng ý
        </CButton>
        &nbsp;
        <CButton color="secondary" class="btn-action-primary" @click="configStationModal = false"
                 :disabled="dataConfigStation.loading.value">
          <i class="fa fa-times"></i> Đóng
        </CButton>
      </div>

      <BaseFormLoading :loading="dataConfigStation.loading.value"></BaseFormLoading>
    </CModal>

  </div>
</template>

<script>
import BaseTable from "../../base/BaseDataTable";
import BaseInput from "../../base/BaseInput";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseFormLoading from "@/views/base/BaseFormLoading";

export default {
  name: "AudioDeviceList",
  components: {
    BaseTable,
    BaseInput,
    BaseSelect,
    BaseFormLoading
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    return {
      actionData: {
        model: {
          selectedAll: false,
          fileSelectedId: null,
          fileSelectedName: null,
          listDeviceSelectedId: []
        }
      },
      stationIdSelect: {
        options: {
          label: "Nhóm truyền thanh",
          selectAllText: "Tất cả nhóm truyền thanh",
          filter: true,
          keyField: "value",
          valueField: "text",
        },
        data: {
          model: "",
          name: "stationId",
          source: {
            url: "/audio-station/list-audio-station",
            response: function (dataResponse) {
              return dataResponse.data;
            },
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      deviceCodeInput: {
        options: {
          placeholder: "Mã thiết bị",
          label: 'Mã thiết bị'
        },
        data: {
          name: "deviceCode",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      configStationModal: false,
      dataConfigStation: {
        loading: {value: false},
        id: {
          data: {
            name: "id",
            model: ""
          }
        },
        stationIdSelect: {
          options: {
            label: "Nhóm truyền thanh",
            selectAllText: "Chọn nhóm truyền thanh",
            filter: true,
            keyField: "value",
            valueField: "text",
            lazyLoad: true
          },
          data: {
            model: "",
            name: "stationId",
            source: {
              url: "/audio-station/list-audio-station",
              response: function (dataResponse) {
                that.configStationModal = true;
                return dataResponse.data;
              },
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataConfigStation.stationIdSelect.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Nhóm truyền thanh không được để trống";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              },
            },
          },
        },
      },
      mainTable: {
        options: {
          fields: [
            {key: "index", label: "STT", sorter: false, filter: false},
            {key: "updateDate", label: "Cập nhật cuối"},
            {key: "deviceCode", label: "Mã thiết bị"},
            {key: "volume", label: "Âm lượng"},
            {key: "activeStatus", label: "Trạng thái hoạt động"},
            {key: "connectStatus", label: "Trạng thái kết nối"},
            {key: "description", label: "Mô tả"},
            {key: "stationName", label: "Nhóm truyền thanh"},
            {key: "action", label: "Thao tác", _style: "width:10%;"},
          ],
          slots: ["index", "updateDate", "activeStatus", "connectStatus", "volume", "stationName", "action"],
          columnFilter: false,
          tableFilter: false,
          sorter: true
        },
        dataSource: {
          url: "/audio-devices/getPages",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    configStation(item) {
      let that = this;
      this.$refs.dataConfigStation.loadData();
      this.dataConfigStation.id.data.model = item.id;
      setTimeout(() => {
        that.dataConfigStation.stationIdSelect.data.model = item.stationId;
      }, 200)
    },
    submitConfigStation() {
      let that = this;
      if (!this.dataConfigStation.stationIdSelect.data.validator.valid()) {
        return;
      }
      that.dataConfigStation.loading.value = true;
      this.$helper.loadDataSource({
        url: "/audio-devices/configStation",
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            stationId: that.dataConfigStation.stationIdSelect.data.model,
            id: that.dataConfigStation.id.data.model
          };
        },
        successCallback: function (response) {
          that.dataConfigStation.loading.value = false;
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({message: "Gán nhóm truyền thanh thành công"});
            that.configStationModal = false;
            that.loadDataMainTable();
          }
        },
        errorCallback: function (error) {
          that.dataConfigStation.loading.value = false;
          that.$helper.handleError(that.$router, error);
        }
      });
    }
  },
  created: function () {
  },
  mounted() {
  },
  watch: {},
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
